/* eslint-disable */
import { produce } from "immer";
import {
  CMS_FUND_LIST_FETCH_START,
  CMS_FUND_LIST_FETCH_SUCCESS,
  CMS_FUND_LIST_FETCH_FAILURE,
} from "../actions/types";

const cmsFundListReducer = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case CMS_FUND_LIST_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case CMS_FUND_LIST_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case CMS_FUND_LIST_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default cmsFundListReducer;
